// Margin helpers (HT): sale price TTC / (1 + vat) − cheapest supplier purchase price
// Primary supplier if set (and priced), else cheapest priced supplier
export const referenceSupplier = (product) => {
  const links = (product.suppliers || []).filter(s => s.purchase_price != null && s.purchase_price !== '' && !Number.isNaN(Number(s.purchase_price)));
  if (!links.length) return null;
  return links.find(s => s.supplier_id === product.primary_supplier_id) || links.reduce((a, b) => (Number(b.purchase_price) < Number(a.purchase_price) ? b : a));
};

export const marginOf = (product, vatRate = 20) => {
  const ref = referenceSupplier(product);
  const saleHt = Number(product.price) / (1 + vatRate / 100);
  if (!ref || !saleHt) return { saleHt, purchase: null, margin: null, pct: null, level: 'none' };
  const purchase = Number(ref.purchase_price);
  const margin = saleHt - purchase;
  const pct = saleHt ? (margin / saleHt) * 100 : 0;
  return { saleHt, purchase, margin, pct, level: pct >= 30 ? 'good' : pct >= 15 ? 'medium' : 'low' };
};

export const MARGIN_STYLE = {
  good: 'bg-green-100 text-green-700',
  medium: 'bg-amber-100 text-amber-700',
  low: 'bg-red-100 text-red-700',
  none: 'bg-gray-100 text-gray-500',
};

export const marginTitle = (m, vatRate = 20) => m.level === 'none'
  ? 'Aucun prix d\'achat fournisseur renseigné'
  : `PV HT ${m.saleHt.toFixed(2)} € (TTC ÷ ${(1 + vatRate / 100).toFixed(2)}) − PA HT ${m.purchase.toFixed(2)} € = ${m.margin.toFixed(2)} € (${m.pct.toFixed(1)} %)`;

// Suggested TTC price for a target margin (HT), rounded up to x.99
export const suggestedPrice = (product, vatRate = 20, defaultMargin = 35) => {
  const ref = referenceSupplier(product);
  if (!ref) return null;
  const prices = [Number(ref.purchase_price)];
  const margin = product.target_margin_pct == null || product.target_margin_pct === '' ? defaultMargin : Number(product.target_margin_pct);
  if (margin >= 100) return null;
  const ttc = (Math.min(...prices) / (1 - margin / 100)) * (1 + vatRate / 100);
  let rounded = Math.ceil(ttc) - 0.01;
  if (rounded < ttc) rounded += 1;
  const current = Number(product.price) || 0;
  return { purchase: Math.min(...prices), margin, price: Math.round(rounded * 100) / 100, below: current + 0.005 < rounded };
};
